import { Helmet } from "react-helmet-async"
import Stack from "react-bootstrap/Stack"
import styles from "./styles"
import Hero from "./Hero"

export default function Instructions() {
		const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "Salusion Referral Program | Earn $42 Per Participant ",
		"description": "Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients.",
		"brand": {
			"@type": "Brand",
			"name": "Salusion"
		},
		"offers": [
			{
				"@type": "Offer",
				"name": "ICHRA",
				"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "QSEHRA",
				"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "GCHRA",
				"description": "Group Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "EBHRA",
				"description": "Excepted Benefit Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
		],
		"image": "https://salusion.com/assets/images/Generic.png",
		"url": "https://salusion.com",
	}
	return (
		<>
			<Helmet>
				<title>Support Better Benefits and Get Rewarded | Salusion</title>
				<meta name="title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta name="description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta name="keywords" content="Small Business HRA administration software, ICHRA, QSEHRA, Affordable HRA, tax-free benefit, GCHRA, EBHRA" />
				<link rel="canonical" href="https://salusion.com" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta name="twitter:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />

				<meta property="og:title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta property="og:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:image:alt" content="Salusion logo and healthcare savings" />
				<meta property="og:url" content="https://salusion.com/referral-program" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Salusion" />
				<meta property="og:locale" content="en_US" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
			<Hero />
			<section style={styles.section}>
				<div id="referral" className="container" style={styles.container}>
					<Stack gap={4} className="hra-wrapper">
						<Stack gap={3}>
							<h2 style={styles.header}>Getting Started</h2>

							<p style={styles.text}>
								If you already have a Salusion account, log in and go to the referral section. If you don't have an
								account yet, click the "Create Referral Account" button above to set up your login and password.
							</p>
							<br />
						</Stack>

						<Stack gap={3}>
							<h2 style={styles.header}>How It Works</h2>

							<p style={styles.text}>
								Salusion pays program members $42 per participant for ICHRAs and QSEHRAs, and $15 per participant for
								EBHRAs and GCHRAs. A participant is any employee at the referral company who generates three months of
								fees within the first three months of their initial plan year. Payments will be sent to the referrer's
								account in the third month of the company's initial plan year.
							</p>
							<p style={styles.text}>
								Referrals must be submitted before the referred company creates an account with Salusion, and only one
								referral is allowed per company.
							</p>
						</Stack>
					</Stack>
				</div>
			</section>
		</>
	)
}
